import { BaseApiService } from '../../../api/base';
import type { ProductCard } from '../types/partnerOffer';

class PartnerOfferApiService extends BaseApiService {
  async getPartnerLoanOffers(): Promise<ProductCard[]> {
    return this.get<ProductCard[]>('/partners/loan-offers');
  }
}

export const partnerOfferApiService = new PartnerOfferApiService();
